// Constantes pour les rôles utilisateur
export const ROLES = {
  ADMIN: 'admin',
  SERVER: 'server',
  COOK: 'cook',
  BAR: 'bar'
};

// Routes autorisées par rôle
export const ROLE_ROUTES = {
  [ROLES.ADMIN]: ['/admin-dashboard'],
  [ROLES.SERVER]: ['/server-interface'],
  [ROLES.COOK]: ['/cook-interface'],
  [ROLES.BAR]: ['/bar-interface']
};

// Vérification des permissions
export const hasPermission = (userRole, requiredRole) => {
  const roleHierarchy = {
    [ROLES.ADMIN]: 4,
    [ROLES.SERVER]: 3,
    [ROLES.COOK]: 2,
    [ROLES.BAR]: 1
  };
  
  return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
};

// Messages d'erreur par rôle
export const ROLE_ERROR_MESSAGES = {
  [ROLES.ADMIN]: 'Accès administrateur requis',
  [ROLES.SERVER]: 'Accès serveur requis',
  [ROLES.COOK]: 'Accès cuisine requis',
  [ROLES.BAR]: 'Accès bar requis'
};
